import { render, staticRenderFns } from "./Loan.vue?vue&type=template&id=25e12d8b"
import script from "./Loan.vue?vue&type=script&lang=ts"
export * from "./Loan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports